import { schema } from "normalizr";
import instagram from "./instagram";

export default new schema.Array(instagram);
